import { React, useState, Fragment, useRef, useEffect } from "react";
import { useFirestoreConnect } from "react-redux-firebase";
import { Modal } from "antd";
import {
  Box,
  Grid,
  Button,
  Collapse,
  IconButton,
  Typography,
  OutlinedInput
} from "@material-ui/core";
import styled from "styled-components";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import DeleteIcon from "@material-ui/icons/Delete";
import { firestore } from "../../config/firebaseConfig";
import ItemsWithVendorModal from "./ItemsWithVendorModal";
import { Alert } from "@material-ui/lab";
import useNotificationDialog from "../../shared/components/useNotificationDialog";
import { useSelector } from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import { ClickAwayListener } from '@material-ui/core';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AntDataGrid from "../../shared/components/AntDataGrid";


const STypography = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  marginRight: 10,
}));



const MODELS_TYPE = {
  Items: "items",
}

const columns = [
  {
      title: 'ItemCode.', dataIndex: '_', key: 'Stock',
      render: (_, {ItemCode}) => ItemCode ?? ''
  },

  {
      title: 'Month Qt.', dataIndex: '_', key: 'Stock',
      render: (_, {Name}) => Name      ?? ''
  },

  {
      title: 'BARCODE', dataIndex: '_', key: 'Stock',
      render: (_, {UPC}) => UPC ?? 0
  },

];


const ShowLocation = (props) => {
  const { name, email, respEmail, tel, type, handleDelete, Model, id, vendorId, itemsAll } = props;
  const [canEdit, setCanEdit] = useState(false);
  const [edit, setEdit] = useState(name);
  const renameRef = useRef(null);
  const { open, ShowNotificationDialog, handleOpen, handleClose } =
    useNotificationDialog();

  useEffect(() => {
    if (canEdit) {
      if (renameRef !== null) {
        renameRef.current.focus();
      }
    }
  }, [canEdit]);

  
  const updateItemCode = (items, vendorId, itemsAll) =>{
    let itemCodeRef = firestore.collection("items").doc(id) 
    const good = {...itemsAll.Vendors[`${vendorId}`], ItemCode: edit}

    itemsAll.Vendors[`${vendorId}`] = good
    itemCodeRef.set(itemsAll, {merge:true})
  }
  
/*
  const updateItemCode = (items, vendorId, itemsAll) => {
    let itemCodeRef = firestore.collection("items").doc(id)

    let resultItemCode = itemsAll.Vendors[`${vendorId}`]?.Prices.find((p => p.Name === items.Name));

    if (resultItemCode) {
      resultItemCode.ItemCode = edit;
    }

    itemCodeRef.set(itemsAll, { merge: true })
  }
*/
  const hndleOpenEdit = () => {
    setCanEdit(true);
  }

  const handleUpdateOnKeyUpItemCode = (event) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      renameRef.current.blur();
      setCanEdit(false);
    }
    updateItemCode(edit, vendorId, itemsAll);
  };

  const handleUpdateItemCode = () => {
    setCanEdit(false);
    updateItemCode(edit, vendorId, itemsAll);
  }

  return (
    <>
      <Box style={{ border: "1px solid #E4E5EA", padding: 5 }}>
        <Grid container color="green">
          <Grid item xs={3}>
            {" "}
            {!canEdit && <STypography variant="overline"> {name} </STypography>}

            {type === "EDIT" && Model === MODELS_TYPE.Items && !canEdit &&
              <IconButton onClick={hndleOpenEdit} size="small" color="primary">
                <EditIcon fontSize="small" />
              </IconButton>
            }
            {
              canEdit &&
              <ClickAwayListener onClickAway={handleUpdateItemCode}>
                <OutlinedInput
                  ref={renameRef} value={edit}
                  onChange={(e) => setEdit(e.currentTarget.value)}
                  margin="dense"
                  onKeyUp={handleUpdateOnKeyUpItemCode}
                  style={{ marginLeft: 15, marginRight: 15 }}
                />
              </ClickAwayListener>
            }
          </Grid>
          <Grid item xs={3}>
            {" "}
            <STypography variant="overline"> {email} </STypography>{" "}
          </Grid>
          <Grid item xs={4}>
            {" "}
            <STypography variant="overline"> {respEmail} </STypography>{" "}
          </Grid>
          <Grid item xs={2}>
            {" "}
            <STypography variant="overline"> {tel} </STypography>{" "}
          </Grid>
          <Grid container item xs={1}>
            <Grid item>
              {type === "DELETE" && (
                <IconButton onClick={handleOpen} size="small" color="secondary">
                  <DeleteIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {open && (
        <ShowNotificationDialog
          title="SUPPRIMER"
          action={
            <Fragment>
              <Button color="primary" onClick={handleClose}>
                {" "}
                annuler{" "}
              </Button>

              <Button color="secondary" onClick={() => handleDelete(name)}>
                J'accepte Supprimer le stores
              </Button>
            </Fragment>
          }
        >
          <Alert severity="error">
            {" "}
            Vous êtes sur le point de supprimer le store{" "}
          </Alert>
        </ShowNotificationDialog>
      )}
    </>
  );
};

export default function VendorsDetails({
  visible,
  handle2Cancel,
  vendor,
  items,
}) {
  const [locationOpen, setLocationOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);
  const [vendorOpen, setVendorOpen] = useState(false);
  const [modalState, setModalState] = useState(false);

  const handleChangeLocationOpen = () => {
    setLocationOpen(!locationOpen);
  };
  const handleChangeItemOpen = () => {
    setItemOpen(!itemOpen);
  };
  const handleChangeVendorOpen = () => {
    setVendorOpen(!vendorOpen);
  };

  const handleDeleteStore = (name) => {
    let restStore = vendor.Stores.filter((store) => store.Name !== name);
    firestore
      .collection("vendors")
      .doc(vendor.id)
      .set({ Stores: restStore }, { merge: true });

    //console.log(restStore);
  };

  const handle2Open = () => {
    setModalState(true);
  };

  const handleCancel = () => {
    setModalState(false);
  };

  useFirestoreConnect([
    {
      collection: "items",
      where: [[`Vendors.${vendor.id}`, "!=", null]],
      // where: [[`Vendors.${vendor.id}.ItemCode`, "==", null]], 
      limit: 100,
      storeAs: `randomItems_${vendor.id}`,
    },
  ]);
  const itemsSelector = useSelector(
    (state) => {
      // console.log("object"+JSON.stringify(state.firestore));
      return state.firestore.ordered[`randomItems_${vendor.id}`]
    }
  );
  //console.log(itemsSelector);

  const handleItemCode = (item, vendorId) => {
    // console.log(item)
    // console.log(vendorId)
    const itemcode = item?.Vendors[`${vendorId}`]?.Prices[0]?.ItemCode || '';
    // console.log(itemcode);
    return itemcode;
  }



  return (
    <>
      <Modal
        title="Details du Fournisseur"
        visible={visible}
        footer={[]}
        onCancel={handle2Cancel}
        width={700}
      //zIndex= {theme.zIndex.drawer + 2}
      >
        <div>
          <Grid container spacing={2} justify="flex-end">
            <Grid item>
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={handle2Open}
              >
                renseigner le prix des produits
              </Button>
            </Grid>
          </Grid>
        </div>
        <div>
          <Box style={{ height: 10, paddingBottom: 2 }} />

          <Grid container justify="space-between">
            <Grid item>
              <Typography variant="overline" gutterBottom>
                VENDOR INFO :
              </Typography>
            </Grid>
            <Grid item>
              {vendorOpen ? (
                <IconButton onClick={handleChangeVendorOpen}>
                  <KeyboardArrowUpIcon />
                </IconButton>
              ) : (
                <IconButton onClick={handleChangeVendorOpen}>
                  <KeyboardArrowDownIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
          <Collapse in={vendorOpen}>
            <ShowLocation
              name="vendor Name"
              email="vendor Email"
              respEmail="Responsable Email"
              tel="vendor Tel"
              type="HEADER"
            />
            {vendor &&

              <ShowLocation
                name={vendor.Name}
                email={vendor.Email ? vendor.Email : "---"}
                respEmail={vendor.RespEmail ? vendor.RespEmail : "---"}
                tel={vendor.Tel ? vendor.Tel : "---"}
                type="HEADER"
              />
            }
          </Collapse>
        </div>

        <div>
          <Box style={{ height: 10, paddingBottom: 2 }} />

          <Grid container justify="space-between">
            <Grid item>
              <Typography variant="overline" gutterBottom>
                LES LOCATIONS :
              </Typography>
            </Grid>
            <Grid item>
              {locationOpen ? (
                <IconButton onClick={handleChangeLocationOpen}>
                  <KeyboardArrowUpIcon />
                </IconButton>
              ) : (
                <IconButton onClick={handleChangeLocationOpen}>
                  <KeyboardArrowDownIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
          <Collapse in={locationOpen}>
            <ShowLocation
              name="Store Name"
              email="Store Email"
              respEmail="Responsable Email"
              tel="Store Tel"
              type="HEADER"
            />
            {vendor.Stores && vendor.Stores.map((store, idx) => (
              <ShowLocation
                key={idx}
                handleDelete={handleDeleteStore}
                name={store.Name}
                email={store.Email ? store.Email : "---"}
                respEmail={store.RespEmail ? store.RespEmail : "---"}
                tel={store.Tel ? store.Tel : "---"}
                type="DELETE"
              />
            ))}
          </Collapse>
        </div>
        <div>
          <Box style={{ height: 10, paddingBottom: 2 }} />

          <Grid container justify="space-between">
            <Grid item>
              <Typography variant="overline" gutterBottom>
                LES Produits :
              </Typography>
            </Grid>
            <Grid item>
              {itemOpen ? (
                <IconButton onClick={handleChangeItemOpen}>
                  <KeyboardArrowUpIcon />
                </IconButton>
              ) : (
                <IconButton onClick={handleChangeItemOpen}>
                  <KeyboardArrowDownIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
          <Collapse in={itemOpen}>
            <ShowLocation
              name="ItemCode"
              email="ItemName"
              tel=" Barcode"
              type="HEADER"
            />
            {
              /*
              
             <AntDataGrid 
                data={itemsSelector}
                columns={columns} 
                
                shadows 
            />
              */
            itemsSelector &&
              itemsSelector.map((itemsSelector, idx) => (
                 <ShowLocation
                   key={idx}
                   name={handleItemCode(itemsSelector, vendor.id)}
                   email={itemsSelector.Name ? itemsSelector.Name : "---"}
                   tel={itemsSelector.Barcode ? itemsSelector.Barcode : "---"}
                   id={itemsSelector.id}
                   vendorId={vendor.id}
                   itemsAll={itemsSelector}
                   type="EDIT"
                   Model={MODELS_TYPE.Items}
                 />
              ))
              }
          </Collapse>
        </div>
      </Modal>
      {
        <ItemsWithVendorModal
          visible={modalState}
          handleCancel={handleCancel}
          vendor={vendor}
        />
      }
    </>
  );
}
